<template>
  <path
    d="M12 8.00017V6.41017C12 5.52017 13.08 5.07017 13.71 5.70017L19.3 11.2902C19.69 11.6802 19.69 12.3102 19.3 12.7002L13.71 18.2902C13.08 18.9202 12 18.4802 12 17.5902V16.0002H5C4.45 16.0002 4 15.5502 4 15.0002V9.00017C4 8.45017 4.45 8.00017 5 8.00017H12Z"
  />
</template>
